import { useNavigate } from 'react-router';

import { WALLBOARDS_URL } from '../config';
import { Button } from '../components/button/button';

export function PageHeaderButtons() {
    const navigate = useNavigate();

    return (
        <>
        <Button
            variant="label"
            icon="ic_selfservice"
            clicked={() => navigate(WALLBOARDS_URL)}>
            Wallboards
        </Button>
        </>
    );
}

export function PageFooterContent() {
    const navigate = useNavigate();

    return (
        <>
            <nav>
                <Button
                    variant="label"
                    clicked={() => navigate(WALLBOARDS_URL)}>
                    Wallboards
                </Button>
            </nav>
            <p className="footer-subtext">
                Two Color illustrations from <a href="https://www.manypixels.co/gallery" target="_blank" rel="noreferrer">ManyPixels.co</a>
            </p>
        </>
    );
}